<template>
  <div style="height: 100%;">
    <div class="contentbox">
      <div class="content">
        <div class="logo">
          <!-- <img :src="`${IP_TEST}/uploads/${logopic}`" height="102" alt="" @click="$router.push('/')"> -->
        </div>
        <div class="inqtype" >
          <ul>
            <li @click="inqType = 'gr'">
              <a href="javascript:;;" :class="inqType == 'gr' ? 'active' : ''">
                个人会员
              </a>
            
            </li>
            <li @click="inqType = 'dw'">
              <a href="javascript:;;" :class="inqType === 'dw' ? 'active' : ''" >
                单位会员
              </a>
            
            </li>
            <li @click="inqType = 'ban'">
              <a href="javascript:;;" :class="inqType === 'ban' ? 'active' : ''" >
                备案查询
              </a>
            </li>
          </ul>
        </div>
        <div class="inqBox">
            <!-- <a class="back" href="/">返回主页</a> -->
            <div class="allbox">
               <div class="rightBox">
                  <!-- <img src="/static/img/img/bgtuut.png" alt=""> -->
                </div>
              <div class="leftBox">
                <div class="title">
                  {{ inqType | getTitle }}
                </div>
                <div v-if="inqType=='gr'">
                  <div class="textbox">
                    <input type="text" v-model="cert.name" class="inname" placeholder="请输入姓名"/>
                  </div>
                  <div class="textbox">
                    <input type="text" v-model="cert.code" class="incert" placeholder="请输入会员证号"/>
                  </div>
                </div>
                <div v-else-if="inqType=='ban'">
                  <div class="textbox"><input type="text" v-model="cert.companyname" class="inname" placeholder="请输入企业名称"/></div>
                  <div class="textbox"><input type="text" v-model="cert.code" class="incert" placeholder="请输入备案登记号"/></div>
                </div>
                <div v-else>
                  <div class="textbox"><input type="text" v-model="cert.companyname" class="inname" placeholder="请输入企业名称"/></div>
                  <div class="textbox"><input type="text" v-model="cert.code" class="incert" placeholder="请输入会员证号"/></div>
                </div>
                <button @click="submitForm() ">查询</button>
               
              </div>
             
            </div>
        </div>
        <div class="memberfile">
          <div class="filetitle">
            <h2>
              <img src="/static/img/img/fuajin.png" alt="">
            附会员申请表格
            </h2>
          </div>
          <div class="filelist">
            <ul>
              <li v-for="(file, index) in applyFiles" :key="index">
                <router-link v-if="!file.filesrc" :to="`/news/info/${file.plateid}/${file.uuid}`">
                  {{ file.title }}
                </router-link>
                <a v-else :href="`${IP_TEST}/uploads/${file.filesrc}`" >{{ file.title }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="recodenum">备案号：{{ recodenum }}</div>
      </div>
     
    </div>
  </div>
    
</template>
<script>
  
  import { getPersonalMember,getCompanyMember ,getBeiAn } from '@/request/index';
  import { getCertTypes,getFindPage ,getArticles} from '@/request/get';
  import { IP_TEST } from '@/config'
  const rate = window.outerWidth / 1920;
  export default {
    metaInfo: {
      title: '北京软数人才测评网',
      meta: [
        {
          name: 'viewport', content:
            `width=1920, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`
        }
      ]
    },
    name: "inquery",
    components: {
    },
    computed:{
    logopic() {
      return this.$store.getters.logopic;
      },
    recodenum() {
      return this.$store.getters.recodenum;
    },
  },
    data() {
      return {
        occupations: [],
        occupationFlag:false,
        cert: {
          name: "",
          code:"",
          companyname:""
        },
        applyFiles:[],
        selcertname:"",
        gourl:"",
        certTypes:[],
        inqType:'gr',
        IP_TEST
      }
  },
  filters: {
    getTitle(value) {
      if (value == 'gr') {
        return '个人会员';
      }
      if (value == 'dw') {
        return '单位会员';
      }
      if (value == 'ban') {
        return '备案查询';
      }
    }
  },
    created(){
     if(this.$route.query&&this.$route.query.inqtype)
      this.inqType = this.$route.query.inqtype;
     this.getCertTypes();
     this.getFindPage();
  
    },
    mounted() {
      var lastTouchEnd = 0;
      document.addEventListener(
        "touchend",
        function (event) {
          var now = new Date().getTime();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        },
        false
      );
    },
    methods: {
      async getFindPage() {
        let result = await getFindPage();
        result = result.data || [];
        this.$store.dispatch("SET_PLATES", result)
        let { plates } = this.$store.state;
        let list = plates.filter((item) => '会员附件' == item.name);
        let uuid = list[0].uuid;
        result =  await getArticles(uuid);
        this.applyFiles = result.data ||[];
      },
      goHome() {
        this.$router.push("/");
      },
      handleInq() {
        if (!this.selcertname) {
          this.$message.error("请选择职业名称");
          return;
        }
        for(let i=0;i<this.occupations.length;i++)
        { 
          if(this.occupations[i].certname==this.selcertname)
          {
            this.cert = this.occupations[i];
            break;
          }
        }
        this.$router.push({
          name: "Show",
          query: {
            name: this.cert.name,
            code: this.cert.code,
            certtypename: this.cert.certtypename
          }
        })
      },
      async getCertTypes(){
        let result = await getCertTypes();
        this.certTypes = result.data;
      },
      /**
       *  cname: "单位名称"或姓名,
          ccode: "信用代码"或证件号,
          bzcode: "证书编号"或标准号
      */
      async submitForm() {
        if(this.inqType=='gr')
        {
          if ((this.cert.name == "" && this.cert.code == "")) {
            return;
          }
          let result =await getPersonalMember(this.cert.name,this.cert.code);
          if(result.data.length>0)
          {
            this.$router.push({
              name: "MemberRlt",
              query: {
                name: this.cert.name,
                code: this.cert.code,
                inqType:"gr"
              }
            })
          }else{
            this.$message.error("您输入的会员信息不存在，谨防假冒。");
          }
        }else if(this.inqType=='dw'){
          if ((this.cert.companyname == "" && this.cert.code == "")) {
            return;
          }
          let result =await getCompanyMember(this.cert.companyname,this.cert.code);
          if(result.data.length>0)
          {
            this.$router.push({
              name: "MemberRlt",
              query: {
                companyname: this.cert.companyname,
                code: this.cert.code,
                inqType:"dw"
              }
            })
          }else{
            this.$message.error("您输入的会员信息不存在，谨防假冒。");
          }
        }else if(this.inqType=='ban'){
          if ((this.cert.companyname == "" && this.cert.code == "")) {
            return;
          }
          let result =await getBeiAn(this.cert.companyname,this.cert.code);
          if(result.data.length>0)
          {
            this.$router.push({
              name: "MemberRlt",
              query: {
                companyname: this.cert.companyname,
                code: this.cert.code,
                inqType:"ban"
              }
            })
          }else{
            this.$message.error("您输入的备案信息不存在，谨防假冒。");
          }
        }
       
      }
    }
  };
</script>

<style scoped>
  .logo{
      text-align: left;
      position: relative;
      top:5px;
  }
  .contentbox{
    position: relative;
    height: 100%;
     
      background-image:url(/static/img/img/bggg.png);
      background-size: cover;
      background-repeat: no-repeat;
  }
  .contentbox .content{
    position: relative;
    width: 1200px;
    min-height: 1077px;
    margin:auto;
  }
  .inqBox{
    position: absolute;
    top:159px;
    left: 34px;
  width: 1132px;
  height: 648px;
  background: #FFFFFF;
  box-shadow: 0px 12px 51px 0px rgba(68,98,207,0.19);
  opacity: 0.9;
  border-radius: 0px 5px 5px 0px;
  }
  .inqBox h1{
      font-size: 32px;
      
      font-weight: bold;
      color: #FFFFFF;
      line-height: 23px;
      text-align: center;
  }
  .leftBox .title{
    position: relative;
    margin-top: 78px;
     margin-bottom: 96px;
height: 35px;
font-size: 35px;
font-family: PingFang SC;
font-weight: bold;
color: #252626;
line-height: 35px;
text-align: center;
  }
  .leftBox .title::after{
    position: absolute;
    content:'';
    top:65px;
    left:265px;
    width: 37px;
height: 8px;
background: #2F8EEC;
border-radius: 3px;
  }
  .leftBox input {
    display: block;
    position: relative;
    margin-top: 42px;
    padding-left: 90px;
    width: 374px;
  height: 67px;
  background: #F2F4F9;
  border-radius: 5px;
  color: #333333;
  font-size: 21px;
  }
  .textbox{
    position: relative;
    margin-left: 52px;
    width: 464px;
height: 67px;
background: #F2F4F9;
border-radius: 5px;
  }
   .textbox::before{
    content:'';
    position: absolute;
    top:21px;
    left: 72px;
    width: 1px;
height: 25px;
background: #E3E6EF;
z-index: 1;
   }
  .leftBox input::placeholder{
font-size: 21px;
font-family: PingFang SC;
font-weight: 400;
color: #9BA1A8;
line-height: 67px;
    }

   .leftBox input.inname{
    background-image: url(/static/img/img/ixngm.png);
    background-repeat: no-repeat;
    background-size: 26px 25px;
    background-position: 23px center;
   }
 .leftBox input.incert{
    background-image: url(/static/img/img/shegnn.png);
    background-repeat: no-repeat;
    background-size: 35px 29px;
    background-position: 19px center;
   }
  .leftBox button {
    margin-top: 57px;
    margin-left: 52px;
    width: 464px;
  height: 67px;
  background: #2F8EEC;
  border-radius: 5px;
font-size: 29px;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 67px;
  }
  .allbox{
    height: 369px;
    display: flex;
  }
  .leftBox{
    width:566px;
    /* height: */
    height: 648px;
    display: inline-block;
  }
  .rightBox{
    width:566px;
    height: 648px;
    display: inline-block;
    background-image:url(/static/img/img/bgtuut.png);
    background-size: cover;
  }
  .intype >>>.el-input__inner{
    background-color:transparent;
    border:none;
    height: 46px;
      line-height: 46px;
      padding:0px;
      font-size: 16px;
      color: #FFFFFF;
  }
  .kouniu2{
    position: relative;
      top: -67px;
      left: 57px;
      width: 52px;
  }
  .inqtype{
    position: absolute;
    top:33px;
    right: 36px;
    width: 426px;
  height: 44px;
  border: 1px solid #E0E3E9;
  font-family: PingFang SC;
  font-weight: 500;
  }
  .inqtype ul li{
    display: inline-block;
    width: 33.33333%;
    text-align: center;
    height: 44px;
  }
  .inqtype ul li a{
    color: #717375;
    font-size: 16px;
    line-height: 44px;
    display: block;
    width: 100%;
    height: 100%;
  }
  .inqtype ul li a.active{
    background: #2F8EEC;
  color: #FFFFFF;
  }
  .memberfile{
    position: absolute;
    top:843px;
    left:33px;
    display: flex;
    min-height: 131px;
  }
  .memberfile img{
    position: relative;
    margin-right: 16px;
  }
  .memberfile .filetitle{
    width: 239px;
    display: inline-block;
  }
  .memberfile .filetitle h2 {
    
    width: 239px;
font-size: 16px;
font-family: PingFang SC;
font-weight: 400;
color: #333333;
line-height:38px;
  }
  .memberfile .filelist{
    display: inline-block;
    text-align: left;
    line-height: 25px;
  }
  .memberfile .filelist a{
    display: block;
    color: #2F8EEC;
    height: 36px;
    line-height: 36px;

font-family: PingFang SC;
    font-size: 16px;
    border-bottom: solid 1px;
  }
  .rightBox img{
    position: relative;
    top: 88px;
    left: 23px;
  }
  .inqBox .back{
    font-size: 16px;
    float: right;
    color: #fff;
    border-bottom: solid 1px;
    margin-top: 20px;
  }
  .recodenum{
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 34px;
    height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #AEB8C3;
    line-height: 14px;
    text-align: center;
  }
</style>
  